import { render, staticRenderFns } from "./TicketsListView.vue?vue&type=template&id=12091c88&"
import script from "./TicketsListView.vue?vue&type=script&lang=js&"
export * from "./TicketsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports